<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-row>
      <v-col cols="12">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex' : ''">
          <v-text-field
            filled
            rounded
            dense 
            :hide-details="true"
            placeholder="Cari kelas . . ."
            v-model="filter.title"
            clearable
            color="#ff618a"
            @click:clear="filter.title = ''; fetch();"
            v-on:keyup.enter="fetch();"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn 
            color="#FF618A "
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="white--text text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            elevation="0"
            rounded
            to="/class/general">
            Tambah Kelas 
          </v-btn>
        </div>
        <div class="my-5">
          <div class="title text--secondary">
            Data Kelas
          </div>
          <div class="caption text--secondary">
            {{ pagination.totalData }} Kelas Ditemukan 
          </div>
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index">
            <v-list dense class="line my-3" :class="$vuetify.breakpoint.name === 'xs' ? 'mr-0' : 'mr-5'">
              <v-list-item
                :to="`/class/${l.id}`">
                <v-list-item-avatar tile class="cursor-pointer" style="box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.3) !important;">
                  <img :src="l.classesUrlCover" style="border-radius: 5px;">
                </v-list-item-avatar>
                <v-list-item-content class="cursor-pointer">
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    {{ l.classesTitle }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mt-1 font-weight-thin"
                    v-if="$vuetify.breakpoint.name !== 'xs'">
                    Judul
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="cursor-pointer" v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2">
                    {{ l.classesDateCreated | date }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mt-1 font-weight-thin" v-if="!$vuetify.breakpoint.name !== 'xs'">
                    Tanggal Pembuatan
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="cursor-pointer" v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2">
                    {{ l.classesCategoryTitle }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mt-1 font-weight-thin" v-if="$vuetify.breakpoint.name !== 'xs'">
                    Kategori
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="cursor-pointer" v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2">
                    {{ l.classesType }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mt-1 font-weight-thin" v-if="$vuetify.breakpoint.name !== 'xs'">
                    Type
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="cursor-pointer" v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2 d-flex" v-if="l.classesJoin">
                    <div>
                      <v-icon>mdi-account</v-icon> {{ l.classesJoin.length }}
                      <v-list-item-subtitle class="caption mt-1 font-weight-thin">
                        Pengguna
                      </v-list-item-subtitle>
                    </div>
                    <div class="mx-5">
                      <v-icon>mdi-bookshelf</v-icon> {{ l.classesSilabus.length }}
                      <v-list-item-subtitle class="caption mt-1 font-weight-thin">
                        Silabus
                      </v-list-item-subtitle>
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content class="text-right">
                  <div>
                    <v-btn 
                      fab
                      x-small
                      dark
                      color="#269B91"
                      elevation="0"
                      class="text-capitalize ma-1"
                      :to="`/class/general?id=${l.id}`">
                      <v-icon small>mdi-square-edit-outline</v-icon>
                    </v-btn>
                    <!-- <v-btn 
                      fab
                      x-small
                      dark
                      color="red"
                      elevation="0"
                      class="text-capitalize ma-1">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn> -->
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Kelas"/>
          <div v-if="pagination.totalPage > 1">
            <v-row>
              <v-col cols="5">
                <div class="body-2	font-weight-bold mt-4">
                  Total {{ pagination.totalData }} data
                </div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="#FF618A"
                    @input="fetch(page)"
                    circle>
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import Empty from "../../../components/DataEmpty";
  
  export default {
    data () {
      return {
        filter: {
          title: ""
        },
        list: [],
        pagination: {},
        page: 1,
        process: {
          run: false
        }
      }
    },
    components: {
      Empty 
    },
    computed: {
      
    },
    mounted () {
      window.scrollTo(0, 0)
      this.fetch()
    },   
    methods: {
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true
        await get(`api/internal/class`, {
          params: {
            pagenum: p,
            limit: 10,
            title: this.filter.title
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      }
    }
  }
</script>

